import React from 'react';
import type { HTMLAttributes, Ref, ElementRef } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import { useFormControl } from '../FormControl';
import type { FormControlOptions } from '../FormControl';

import styles from './Input.styles';

export interface InputProps
  extends Omit<
      HTMLAttributes<HTMLInputElement>,
      'label' | 'disabled' | 'readOnly' | 'required' | 'size'
    >,
    FormControlOptions {
  /**
   * Define the input size.
   */
  size?: 'xs' | 'sm' | 'md';

  /**
   * The HTML input `type` attribute
   */
  type?: 'text' | 'search' | 'password';

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLInputElement>;

  /**
   *
   */
  css?: StitchesCSS;
}

const InputEl = styled('input', styles);

const Input = React.forwardRef<ElementRef<typeof InputEl>, InputProps>(
  (props, ref) => {
    const input = useFormControl(props);

    return <InputEl ref={ref} {...input} />;
  }
);

Input.displayName = 'Input';

export default Input;
